/* global __PRODUCTION */

import React, { PropTypes, Component } from 'react';
import { AppStore, AuthStore } from 'stores';
import { mixin, RefluxMixin } from 'Util';
import App from 'components/App';

import { addMessages } from 'oxygen-i18n';

try {
  const messages = require('../../locale/messages.json');
  addMessages(messages);
} catch (e) {
  // console.log(e)
  // Nothing going on
}

export default class AppContainer extends mixin(RefluxMixin, Component) {
  static displayName = 'AppContainer';

  static propTypes = {
    children: PropTypes.node
  };

  static childContextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(AuthStore, 'auth');
    this.listenToStore(AppStore, 'app');
  }

  render() {
    const {
      loggedIn,
      locale,
    } = this.state.auth;
    const { message, reportBug } = this.state.app;
    return (
      <App
        {...this.props}
        locale={locale}
        loggedIn={loggedIn}
        message={message}
        reportBug={reportBug}
      >
        {this.props.children}
      </App>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/AppContainer.js